// ── localStorage keys ────────────────────────────────────────────────────────
export const STORAGE_KEYS = {
  APP_SYNC_URL:             'appSyncUrl',
  USER_POOL_ID:             'userPoolId',
  APP_CLIENT_ID:            'appClientId',
  API_GATEWAY_URL:          'apiGatewayUrl',
  NOTIFICATION_GRAPHQL_URL: 'notificationGraphqlUrl',
  ACCESS_TOKEN:             'access_token',
  TOKEN:                    'token',
} as const;

// ── OIDC / Cognito ────────────────────────────────────────────────────────────
export const OIDC_CONFIG = {
  SCOPE:                          'openid profile email',
  MAX_ID_TOKEN_IAT_OFFSET_SECS:   30,
  RESPONSE_TYPE:                  'code',
} as const;

// ── Toastr ────────────────────────────────────────────────────────────────────
export const TOASTR_CONFIG = {
  timeOut:            10000,
  positionClass:      'toast-bottom-right',
  preventDuplicates:  true,
  easeTime:           500,
  closeButton:        true,
  progressBar:        true,
} as const;

// ── Validation ────────────────────────────────────────────────────────────────
export const NOTES_MAX_LENGTH = 256;

// ── Routes ────────────────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  FORBIDDEN:  '/forbidden',
  SIGNOUT:    '/signout',
} as const;
